import NotFound from 'components/NotFound';
import UserActivateError from 'components/user/Activate/Error';
import UserActivateInitiate from 'components/user/Activate/Initiate';
import UserActivateNewPhone from 'components/user/Activate/NewPhone';
import UserActivateStart from 'components/user/Activate/Start';
import UserActivateSuccess from 'components/user/Activate/Success';
import UserActivateVerifyPhone from 'components/user/Activate/VerifyPhone';
import UserActivateWrapper from 'components/user/Activate/Wrapper';

const USER_ACTIVATION = [
  {
    path: 'activate',
    element: <UserActivateWrapper />,
    children: [
      {
        path: 'initiate/:token',
        element: <UserActivateInitiate />
      },
      {
        path: 'start',
        element: <UserActivateStart />
      },
      {
        path: 'error',
        element: <UserActivateError />,
        children: [
          {
            path: ':kind',
            element: <UserActivateError />
          },
          {
            path: '*',
            element: <UserActivateError />
          }
        ]
      },
      {
        path: 'confirm-code',
        element: <UserActivateVerifyPhone />
      },
      {
        path: 'new-phone',
        element: <UserActivateNewPhone />
      },
      {
        path: 'success',
        element: <UserActivateSuccess />
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
];

export default USER_ACTIVATION;
